import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateColumns } from 'bundles/apex/pipeline/settings/store/actions';

import AddControl from 'components/add_control';
import CustomColumn from './custom_column';

export function CustomColumnsSettings({ columnOptions, selectedColumns, updateColumns }) {
  const { all, available } = columnOptions;

  function handleColumnUpdate(index, value) {
    const columns = [...selectedColumns];
    columns.splice(index, 1, value);
    updateColumns(columns);
  }

  function handleAddColumn() {
    updateColumns([...selectedColumns, columnOptions.available[0].value]);
  }

  function handleRemoveColumn(index) {
    updateColumns(selectedColumns.filter((_, i) => i !== index));
  }

  return (
    <div className="custom-columns">
      {selectedColumns.map((value, index) => (
        <CustomColumn
          allOptions={all}
          availableOptions={available}
          // the 2 first columns are fixed and should not be deleted
          canDelete={index > 1}
          columnIndex={index}
          key={index}
          value={value}
          onChange={handleColumnUpdate}
          onDelete={() => handleRemoveColumn(index)}
        />
      ))}
      {available.length > 0 && <AddControl onClick={handleAddColumn}>Add Custom Column</AddControl>}
    </div>
  );
}

CustomColumnsSettings.propTypes = {
  columnOptions: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    available: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  columnOptions: state.columnOptions,
  selectedColumns: state.view.columns,
});

const mapDispatchToProps = {
  updateColumns,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomColumnsSettings);
